import { useAuthLinks } from '@/hooks/useAuthLinks';
import { useBreadcrumb } from '@/hooks/useBreadcrumb';
import { useComponentFactory } from '@/hooks/useComponentFactory';
import { useImageCarousel } from '@/hooks/useImageCarousel';
import { useJellybooks } from '@/hooks/useJellybooks';
import { useMenuToggle } from '@/hooks/useMenuToggle';
import { useMiniBasket } from '@/hooks/useMiniBasket';
import { useNewsletterSignup } from '@/hooks/useNewsletterSignup';
import { useOtherFormats } from '@/hooks/useOtherFormats';
import { useProductDetails } from '@/hooks/useProductDetails';
import { useProductPurchasing } from '@/hooks/useProductPurchasing';
import { usePromoBadge } from '@/hooks/usePromoBadge';
import { useTooltips } from '@/hooks/useTooltips';
import { useQuickPay } from '@/hooks/useQuickPay';
import { useViewItem } from '@/hooks/useViewItem';
import { usePageData } from '@/contexts/pageContext';

export const ProductApp = () => {
  const authLinks = useAuthLinks();
  const menuToggle = useMenuToggle();
  const miniBasket = useMiniBasket();
  const breadcrumb = useBreadcrumb();
  const componentFactory = useComponentFactory();
  const imageCarousel = useImageCarousel();
  const promoBadge = usePromoBadge();
  const otherFormats = useOtherFormats();
  const purchaseOptions = useProductPurchasing();
  const productDetails = useProductDetails();
  const lookInside = useJellybooks();
  const tooltips = useTooltips();
  const newsletterSignup = useNewsletterSignup();
  const { isQuickPayEnabled } = usePageData();

  useViewItem();

  // useQuickPay will automatically find the .quickpay element and read its attributes
  const quickPay = useQuickPay();

  return (
    <>
      {authLinks}
      {menuToggle}
      {miniBasket}
      {breadcrumb}
      {componentFactory}
      {imageCarousel}
      {promoBadge}
      {otherFormats}
      {purchaseOptions}
      {productDetails}
      {lookInside}
      {tooltips}
      {newsletterSignup}
      {isQuickPayEnabled ? quickPay : null}
    </>
  );
};
